import DateFunc from '@/lib/lyg/date_func';
import strFunc from "@/lib/lyg/string";

class GetOrderUser {
  static get_order_user_by_core_date(inData: any) {
    let opt_obj = {
      select_date: "",
      info_arr: [],
      subject_name: "",
      ...inData
    };
    let info_arr = opt_obj.info_arr;

    //데이터 모으기
    let core_date_json_arr: any = {};
    let core_date_arr = [];
    for (let i = 0; i < info_arr.length; i++) {
      let info = info_arr[i];
      let daily_report = null;
      let core_date = opt_obj.select_date;
      if (info.daily_report_arr) {
        for (let d_i = 0; d_i < info.daily_report_arr.length; d_i++) {
          let row_daily = info.daily_report_arr[d_i];
          if (row_daily["a_subject"] == opt_obj.subject_name
            && row_daily["a_date"] == opt_obj.select_date) {
            daily_report = row_daily;
          }
        }
      }

      if (daily_report && daily_report.textbook_use && daily_report.textbook_use.a_re_start_date) {
        core_date = daily_report.textbook_use.a_re_start_date;
      }

      if (core_date_json_arr[core_date] == undefined) {
        core_date_arr.push(core_date);
        core_date_json_arr[core_date] = [];
      }
      core_date_json_arr[core_date].push(info);
    }

    //정렬
    core_date_arr.sort((a: any, b: any) => {
      let a_date = new Date(a);
      let b_date = new Date(b);
      return b_date.getTime() - a_date.getTime();
    });

    //다시 모으기
    let new_info_arr: any = [];
    for (let i = 0; i < core_date_arr.length; i++) {
      let core_date = core_date_arr[i];
      let core_date_info_arr = core_date_json_arr[core_date];
      new_info_arr = [
        ...new_info_arr,
        ...core_date_info_arr
      ];
    }

    return new_info_arr;
  }
}
export default GetOrderUser;